/**
 * Scrub leftover cloud-checkout marketing phrases from merchant site copy.
 * Local-only commerce (COMMERCE.md): never suggest Stripe / Apple Pay / Google Pay wallets.
 */

const CLOUD_MARKETING_RES: Array<{ re: RegExp; to: string }> = [
  { re: /\bstripe[\s-]*ready\b/gi, to: 'Local' },
  { re: /\bstripe\s+checkout\b/gi, to: 'local checkout' },
  { re: /\bsichere\s+zahlung\s+mit\s+stripe\b/gi, to: 'Lokale Überweisung (SEPA)' },
  { re: /\bsecure\s+payment\s+with\s+stripe\b/gi, to: 'Local bank transfer (SEPA)' },
  { re: /\bzahlung\s+mit\s+stripe\b/gi, to: 'lokale Überweisung' },
  { re: /\bpay\s+with\s+stripe\b/gi, to: 'pay locally' },
  { re: /\bstripe[\s-]*karten?(?:\s+sobald[^.\n]*)?/gi, to: 'lokale Zahlungen' },
  { re: /\bstripe\b/gi, to: 'local payment' },
  { re: /\bapple\s*pay\s*&\s*google\s*pay\b/gi, to: 'GiroCode / Zahlungs-QR' },
  { re: /\bapple\s*pay\b/gi, to: 'GiroCode' },
  { re: /\bgoogle\s*pay\b/gi, to: 'Zahlungs-QR' },
];

const DETECT_RE =
  /\bstripe\b|\bapple\s*pay\b|\bgoogle\s*pay\b/i;

/** Replace known cloud-checkout marketing phrases with local-checkout wording. */
export function scrubCloudCheckoutMarketingCopy(text: string): string {
  if (!text) return text;
  let out = text;
  for (const { re, to } of CLOUD_MARKETING_RES) {
    out = out.replace(re, to);
  }
  return out;
}

export function containsCloudCheckoutMarketing(text: string): boolean {
  if (!text) return false;
  return DETECT_RE.test(text);
}
